import React from 'react'
import MessageUtils from '../../../util/MessageUtils'
import TextInputSF from '../../../widgets/input/TextInputSF'
import DatePickerSF from '../../../widgets/input/DatePickerSF'
import SelectSingleSF from '../../../widgets/input/SelectSingleSF'
import ViewOrUpdate2UI from '../../../widgets/layout/ViewOrUpdate2UI'
import CardUI from '../../../widgets/layout/CardUI'
import TaskUsersUI from './TaskUsersUI'
import './TaskDetailTop.css'

const TaskDetailTopUI = ({context, messageList, project, task,
    editStatus, onEditStatusClick, onStatusChange, statusList,
    editPriority, onEditPriorityClick, onPriorityChange, priorityList,
    editDueDate, onEditDueDateClick, onDueDateChange,
    editAssignee, onEditAssigneeClick, onAssigneeChange, projectUserList,
    editTaskUsers, onEditTaskUsersClick, onTaskUsersChange, onTaskUsersSubmit,
    taskUserList, taskUserIdList, projectUserMap,
    editTaskNotes, onEditTaskNotesClick, onTaskNotesChange, onTaskNotesCancel,
    onDropDownClickOutside, onDatePickerClickOutside,
  }) =>
  <CardUI className='c_tsk_dtl_top'>
    {
      task.taskList.length === 0 &&
      <div className='short'>
        {
          project.projectType !== 'template' &&
          <TaskStatusUI
            context={context}
            messageList={messageList}
            project={project}
            task={task}
            statusList={statusList}
            editMode={editStatus}
            onEditClick={onEditStatusClick}
            onChange={onStatusChange}
            onClickOutside={onDropDownClickOutside}
          />
        }
        <TaskPriorityUI
          context={context}
          messageList={messageList}
          project={project}
          task={task}
          priorityList={priorityList}
          editMode={editPriority}
          onEditClick={onEditPriorityClick}
          onChange={onPriorityChange}
          onClickOutside={onDropDownClickOutside}
        />
        {
          project.projectType !== 'template' &&
          <TaskDueDateUI
            context={context}
            messageList={messageList}
            project={project}
            task={task}
            editMode={editDueDate}
            onEditClick={onEditDueDateClick}
            onChange={onDueDateChange}
            onClickOutside={onDatePickerClickOutside}
          />
        }
        <TaskAssigneeUI
          context={context}
          messageList={messageList}
          project={project}
          task={task}
          projectUserList={projectUserList}
          editMode={editAssignee}
          onEditClick={onEditAssigneeClick}
          onChange={onAssigneeChange}
          onClickOutside={onDropDownClickOutside}
        />
      </div>
    }
    {
      task.taskList.length === 0 &&
      <div className='long'>
        <TaskUsersUI
          context={context}
          project={project}
          messageList={messageList}
          taskUserList={taskUserList}
          taskUserIdList={taskUserIdList}
          projectUserMap={projectUserMap}
          projectUserList={projectUserList}
          task={task}
          editMode={editTaskUsers}
          onEditClick={onEditTaskUsersClick}
          onChange={onTaskUsersChange}
          onSubmit={onTaskUsersSubmit}
        />
      </div>
    }
    <div className='long'>
      <TaskNotesUI
        context={context}
        messageList={messageList}
        project={project}
        task={task}
        editMode={editTaskNotes}
        onChange={onTaskNotesChange}
        onCancel={onTaskNotesCancel}
        onEditClick={onEditTaskNotesClick}
      />
    </div>
  </CardUI>

const TaskStatusUI = ({context, messageList, project, task, editMode, onEditClick, onChange, onClickOutside, statusList}) =>
  <ViewOrUpdate2UI
    messageList={messageList}
    labelKey='c_status'
    value={statusList.filter(option => option.value === task.status)[0].label}
    editable={project.permissionList.includes('prj_participate')}
    editMode={editMode}
    onEditClick={onEditClick}
  >
    <SelectSingleSF
      optionList={statusList}
      onChange={onChange}
      onClickOutside={onClickOutside}
      selectedKey={task.status}
      menuIsOpen={editMode}
    />
  </ViewOrUpdate2UI>

const TaskPriorityUI = ({context, messageList, project, task, editMode, onEditClick, onChange, onClickOutside, priorityList}) =>
  <ViewOrUpdate2UI
    messageList={messageList}
    labelKey='c_priority'
    value={task.priority ? priorityList.filter(option => option.value === task.priority)[0].label :
      MessageUtils.getMessageValue(messageList, 'c_none')}
    editable={project.permissionList.includes('prj_participate')}
    editMode={editMode}
    onEditClick={onEditClick}
  >
    <SelectSingleSF
      messageList={messageList}
      optionList={priorityList}
      onChange={onChange}
      onClickOutside={onClickOutside}
      selectedKey={task.priority}
      menuIsOpen={editMode}
      removeKey='c_none'
      placeholderKey='c_select'
    />
  </ViewOrUpdate2UI>

const TaskDueDateUI = ({context, messageList, project, task, editMode, onEditClick, onChange, onClickOutside}) =>
  <ViewOrUpdate2UI
    messageList={messageList}
    labelKey='c_due_date'
    value={task.dueDate ? task.dueDate : MessageUtils.getMessageValue(messageList, 'c_none')}
    editable={project.permissionList.includes('prj_participate')}
    editMode={editMode}
    onEditClick={onEditClick}
  >
    <DatePickerSF
      context={context}
      messageList={messageList}
      selectedDateISO={task.dueDateISO}
      onChange={onChange}
      onClickOutside={onClickOutside}
      startOpen={editMode}
      placeholderKey='c_select'
    />
  </ViewOrUpdate2UI>

const TaskAssigneeUI = ({context, messageList, project, task, editMode, onEditClick, onChange, onClickOutside, projectUserList}) =>
  <ViewOrUpdate2UI
    messageList={messageList}
    labelKey='c_assignee'
    value={task.userId ? task.userName : MessageUtils.getMessageValue(messageList, 'c_none')}
    editable={project.permissionList.includes('prj_participate')}
    editMode={editMode}
    onEditClick={onEditClick}
  >
    <SelectSingleSF
      messageList={messageList}
      optionList={projectUserList
        .filter(projectUser => projectUser.roleId !== null)
        .map(projectUser => ({value: projectUser.userId, label: projectUser.name}))
      }
      onChange={onChange}
      onClickOutside={onClickOutside}
      selectedKey={task.userId}
      menuIsOpen={editMode}
      removeKey='c_none'
      placeholderKey='c_select'
    />
  </ViewOrUpdate2UI>

const TaskNotesUI = ({context, messageList, project, task, editMode, onEditClick, onChange, onCancel}) =>
  <ViewOrUpdate2UI
    messageList={messageList}
    labelKey='c_notes'
    value={task.notes ? task.notes : MessageUtils.getMessageValue(messageList, 'c_none')}
    editable={project.permissionList.includes('prj_participate')}
    editMode={editMode}
    onEditClick={onEditClick}
  >
    <TextInputSF
      value={task.notes}
      onSubmit={onChange}
      onCancel={onCancel}
      maxLength={250}
    />
  </ViewOrUpdate2UI>

export default TaskDetailTopUI
